module.exports = __webpack_public_path__ + "media/1.cdcd96d1.wav";